import {Link} from "@tanstack/react-router";
import {ItemBuilder} from "@vesta/global-common-typescript/components/itemBuilder";
import {CONFIG_PAGE_ROUTE_TO, extractConfigPageKey} from "~/workspaceConfig/configPageRoutes";

export function Breadcrumbs({
    items,
}: {
    items: Array<{
        displayName: string;
        to: string | null;
    }>;
    //
}) {
    return (
        <div className="w-full h-[1.5rem] grid grid-flow-col auto-cols-auto gap-x-ds-space-100 justify-start items-center text-ds-font-body text-ds-text-subtle">
            <ItemBuilder
                items={items}
                itemBuilder={(item) => (
                    <BreadcrumbItem
                        displayName={item.displayName}
                        to={item.to}
                        // isLastItem={itemIndex === items.length - 1}
                        key={item.displayName}
                    />
                )}
                spaceBuilder={(spaceIndex) => <BreadcrumbSeparator key={spaceIndex} />}
            />
        </div>
    );
}

function BreadcrumbItem({
    displayName,
    to,
    // isLastItem,
}: {
    displayName: string;
    to: string | null;
    // isLastItem: boolean,
}) {
    if (to === null) {
        return <div className="py-ds-space-025">{displayName}</div>;
    }

    const pageKey = extractConfigPageKey(to);
    const workspaceMatch = to.match(/^\/w\/([^/]+)/);
    if (pageKey !== null && workspaceMatch?.[1] !== undefined) {
        return (
            <Link
                to={CONFIG_PAGE_ROUTE_TO}
                params={{workspaceId: workspaceMatch[1], pageKey: pageKey}}
                className="py-ds-space-025 hover:underline"
            >
                {displayName}
            </Link>
        );
    }

    return (
        <Link
            to={to}
            className={
                "py-ds-space-025 hover:underline"
            }
        >
            {displayName}
        </Link>
    );
}

function BreadcrumbSeparator() {
    return (
        <div
            // className="w-ds-space-100 h-full bg-ds-border-neutral-subtle"
            className="py-ds-space-025"
        >
            /
        </div>
    );
}
